export { default } from './DocumentShowcase';
export type { Props } from './DocumentShowcase';
